import { NumberFormatter as NF } from "~/common/utils/NumberFormatter";
import { NumericFormat } from "react-number-format";

export const PlainFormattedNumber = (props: { value: number }) => (
  <NumericFormat
    displayType={"text"}
    thousandSeparator={NF.getThousandSeparator()}
    decimalSeparator={NF.getDecimalSeparator()}
    value={props.value}
  />
);
